exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".active[data-v-437a6670]{background-color:#000;color:#fff}.filter-icon svg[data-v-437a6670]{height:50px}.categories li.active svg[data-v-437a6670]{fill:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-437a6670","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/site/components/temporary-bhf-filter/bhf-category-switcher.vue
// module id = 65Cr
// module chunks = 3